//@flow
import React from 'react';
import classNames from 'classnames';
import NightLife from 'assets/images/nightlifeIconBlack.png';
import Hospital from 'assets/images/hospitalsIconBlack.png';
import Shopping from 'assets/images/shoppingIconBlack.png';
import Fitness from 'assets/images/fitnessIconBlack.png';
import School from 'assets/images/schoolIconBlack.png';
import Dining from 'assets/images/diningIconBlack.png';
import Airport from 'assets/images/airportIconBlack.png';
import RailwayStation from 'assets/images/railwayStationIconBlack.png';
import Place from 'assets/images/placeIconBlack.png';
// eslint-disable-next-line
import "./styles.scss";

type Props = {
  neighbourhoodType?: string,
  name: string,
  imagePath: string,
  selectedItemId: string,
  typeId: string,
  location: string,
  filterImage?: string,
  distance?: string,
};

export const NeighbourhoodCard = (props: Props) => {
  const { name, distance, selectedItemId, typeId, location, imagePath } = props;

  let cardClassName, card_icon_image;
  if (selectedItemId === typeId) {
    cardClassName = classNames('neighbourhood-card', 'highlight-row');
  } else {
    cardClassName = classNames('neighbourhood-card');
  }

  switch (typeId) {
    case 1:
      card_icon_image = Hospital;
      break;
    case 2:
      card_icon_image = School;
      break;
    case 3:
      card_icon_image = Fitness;
      break;
    case 4:
      card_icon_image = Dining;
      break;
    case 5:
      card_icon_image = Shopping;
      break;
    case 6:
      card_icon_image = NightLife;
      break;
    case 7:
      card_icon_image = Dining;
      break;
    case 8:
      card_icon_image = Airport;
      break;
    case 9:
      card_icon_image = RailwayStation;
      break;
    case 10:
      card_icon_image = Place;
      break;
    default:
      break;
  }

  return (
    <div className={cardClassName}>
      <div className={'img-container'}>
        <div className={'img-div'}>
          <img src={card_icon_image} alt="img" />
        </div>
      </div>
      <div className={'content-container'}>
        <div className={'content'}>
          <h3>{name}</h3>
          <div className={'location-data'}>
            <p>{location}</p>
            <p>{distance}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
